import { topicsData } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-hashtag mr-1"></i>热门话题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            话题标签
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            一键直达你最关心的吃瓜话题分类
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {topicsData.map((topic) => (
            <div
              key={topic.id}
              className={`group flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'bg-primary-100 border border-primary-200/60 hover:bg-primary-200/60 hover:border-primary-300/60'
                  : 'bg-background-50 border border-background-200/60 hover:bg-background-200/40 hover:border-background-300/60'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              )}
              <span className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}